import { IConfiguration } from '../../domain/conf'
import { logger } from '../../utils/common/logger'
import { IIdentityServiceAdapter, ISubscriberServiceAdapter } from './adapters/adapter'
import { LoginRadiusAdapter } from './adapters/loginradius'
import { PianoLoginRadiusSubscriberService } from './adapters/piano/piano-login-radius'

export class IdentityFactory {
    public static async getIdentityInstance(conf: IConfiguration): Promise<IIdentityServiceAdapter> {
        if (!conf.identity) {
            return undefined
        }
        let adapter
        if (conf.identity.sso.vendor === 'loginradius') {
            adapter = new LoginRadiusAdapter(conf)
            await adapter.init()
        }
        return adapter
    }

    public static async getSubscriberInstance(conf: IConfiguration): Promise<ISubscriberServiceAdapter> {
        if (!conf.identity) {
            return undefined
        }
        if (!conf.identity.subscriber) {
            return undefined
        }
        let adapter
        if (conf.identity.sso.vendor === 'loginradius') {
            adapter = new PianoLoginRadiusSubscriberService(conf.identity.subscriber,
                conf.page.isPremium,
                conf.page.isPaywallWhitelisted,
                conf.identity.logo)
            try {
                await adapter.initialize()
            } catch (e) {
                logger('error', 'Failed to initialize subscriber service', e)
            }

        }
        return adapter
    }
}
